import React from 'react';
import { useNavigate } from "react-router-dom";
import '../assets/css/style.css';
import DanLogo from '../assets/img/dan-logo.svg';
import DoneCashback from '../assets/img/DONE-Cashback-System.svg';
import BackIcon from '../assets/img/back-btn.svg';
import EyeIcon from '../assets/img/eye.svg';
import { useState } from 'react';


function NewPasstDan() {
  const navigate = useNavigate(); 


  const [passnew, setpassnew] = useState("");
  const [Rpassnew, setRpassnew] = useState("");



  const handelChangePass = async () => {
    if (passnew !== Rpassnew || !passnew) {
      alert("رمزهای وارد شده یکسان نیستند یا مقدار وارد نشده است!");
      return;
    }
  
    const token = localStorage.getItem("tokenchangepass"); // توکن تأیید تغییر رمز
    const mobile = localStorage.getItem("mobile");
  
    if (!token || !mobile) {
      alert("اطلاعات کافی برای تغییر رمز در دسترس نیست!");
      return;
    }
  
    try {
      const response = await fetch("https://app.doneapp.ir/backend/forget.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams({
          token: token,
          mobile: mobile,
          step: 3,
          new_password: passnew
        }),
      });
  
      if (!response.ok) throw new Error("خطا در ارسال درخواست به سرور!");
  
      const result = await response.json();
  
      if (result.status === "success") {
        alert("رمز عبور شما با موفقیت تغییر یافت!");

      
        localStorage.setItem("donetoken", token);

        localStorage.removeItem("tokenchangepass"); // حذف توکن تغییر رمز

        navigate("/"); // هدایت به صفحه ورود
      } else {
        alert(result.message || "خطایی رخ داده است!");
      }
    } catch (error) {
      console.error("خطا در ارسال درخواست:", error);
      alert("مشکلی پیش آمده، دوباره تلاش کنید!");
    }
  };
  


  return (
    <> 
      <div className=" start-bdy">

        <button className="back-btn-1" onClick={() => navigate("/login")} >
          <img src={BackIcon} alt='back' />
        </button>
        <div className="logomotion tw-200">
          <div className="start-logo">
            <img src={DanLogo} alt="Dan Logo" />
            <img className="mt-15" src={DoneCashback} alt="Done Cashback System" />
          </div>
        </div>

        <div className="loginbtns-2">
          <div className="btndiv-1">
            <div className='forget-title-1' >
            رمز عبور جدید خود را وارد نمایید
            </div>
          
            <div className="mobileinputdiv-1">
              <img className="mobileicon-1" src={EyeIcon} alt="Mobile Icon" />
              <input className="mobileinput-1" type="password"
               value={passnew}
               onChange={(e) => setpassnew(e.target.value)}
              required placeholder="رمز عبور خود را وارد نمایید" />
            </div>

            <div className="mobileinputdiv-1">
              <input className="mobileinput-1" type="password"
               value={Rpassnew}
               onChange={(e) => setRpassnew(e.target.value)}
              
              required placeholder="رمز عبور خود را تکرار نمایید" />
            </div>

            <button type="submit" 
            onClick={handelChangePass}
            
            className="loginbtn-1">
            تغییر رمز عبور
            </button>

           
          </div>
        </div>

       
      </div>
    </>
  );
}

export default NewPasstDan;
